export const eventTypeByActiveByArea = /* GraphQL */ `
  query EventTypeByActiveByArea(
    $reloadYardId: ID
    $activeAreaId: ModelEventTypeEventTypeByActiveByAreaCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventTypeByActiveByArea(
      reloadYardId: $reloadYardId
      activeAreaId: $activeAreaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        active
        areaId
        name
        description
        workflow
        schedule {
          workdays {
            id
            name
            startDayTime
            endDayTime
            selected
          }
          holidays
          minNoticeHours
          maxDaysIntoFuture
          layout
        }
        duration
        bufferTime
        resourceName
        numberOfResources
        assetTypeId
        assetType {
          id
          maxConcurrentBookings
        }
      }
      nextToken
    }
  }
`;

export const timeslotByYearByWeek = /* GraphQL */ `
  query TimeslotByYearByWeek(
    $reloadYardId: ID
    $yearWeek: ModelTimeslotTimeslotByYearByWeekCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeslotByYearByWeek(
      reloadYardId: $reloadYardId
      yearWeek: $yearWeek
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        groups
        status
        reloadYardId
        year
        month
        week
        day
        time
        startTime
        endTime
        inboundId
        inboundShipment {
          status
          state
          poNumber
          railCarNumber
          reloadYardCommodityId
          inventories {
            items {
              productId
              productName
            }
          }
        }
        outboundId
        outboundShipment {
          status
          state
          poNumber
          pickupNumber
          shipWithIds
          railCarNumber
          reloadYardCommodityId
          shipmentLineItems {
            items {
              inventory {
                productId
                productName
              }
            }
          }
        }
        accountName
        accountId
        eventTypeId
        eventType {
          id
          areaId
          name
          description
          duration
          bufferTime
          resourceName
          numberOfResources
          assetTypeId
          assetType {
            id
            maxConcurrentBookings
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
